












// 3rd party libs
import Vue from 'vue';
import {
    mapGetters,
} from 'vuex';

// Helpers
import {
    storage,
} from '@webapp/helpers/generic.js';
import {
    capitaliseString,
} from '@shared/utils/general';

// Components
import alertPanel from '@webapp/components/alert/alert-panel.vue';

// Types
import {
    ALERT,
    AlertType,
} from '@shared/modules/customer-first/types/homepage-notifications';

export default Vue.extend({
    components: {
        alertPanel,
    },
    data() {
        return {
            verificationAlertVisibility: false,
        };
    },
    computed: {
        ...mapGetters([
            'isKycTierLevelValidated',
            'kycLevel2ExpirationStatus',
            'shouldFillAmlQuestionnaire',
        ]),

        ...mapGetters('wallet', ['ledgersByDecentralizedByBalance']),

        availableTokens() {
            // Filter the list of ledgers to include tokens with a balance > 0 and not SSUs
            return this.ledgersByDecentralizedByBalance.filter((ledger) => {
                const ledgerBalance = Number(ledger.balance) + Number(ledger.lockedBalance);

                return ledgerBalance > 0 && ledger.currency.shortCode !== 'SSU';
            });
        },

        currentAlert() {
            return ALERT[this.currentAlertName];
        },

        currentAlertName() {
            if (this.showExpiryVerificationAlert) {
                const type = `${capitaliseString(this.kycLevel2ExpirationStatus)}KycLevel2Request`;

                return AlertType[type];
            }

            if (this.showNotValidatedTokenHolderAlert) {
                return AlertType.NotValidatedTokenHolder;
            }

            return AlertType.UnfilledAmlQuestionnaire;
        },

        hasNotValidatedKycLevel2() {
            return this.isKycTierLevelValidated(1) && !this.isKycTierLevelValidated(2);
        },

        showAlert() {
            return this.showNotValidatedTokenHolderAlert || this.showExpiryVerificationAlert || this.shouldFillAmlQuestionnaire;
        },

        showExpiryVerificationAlert() {
            return this.verificationAlertVisibility && this.kycLevel2ExpirationStatus;
        },

        showNotValidatedTokenHolderAlert() {
            return this.verificationAlertVisibility &&
                this.hasNotValidatedKycLevel2 &&
                this.userHasFanTokens;
        },

        userHasFanTokens() {
            return this.availableTokens?.length;
        },
    },
    created() {
        const verificationAlertVisibility = storage('get', 'verificationAlertVisibility');

        if (verificationAlertVisibility) {
            this.verificationAlertVisibility = verificationAlertVisibility;
        }
    },
    methods: {
        hideIdentityVerificationAlert() {
            this.verificationAlertVisibility = false;
            storage('remove', 'verificationAlertVisibility');
        },

        handleVerificationAlertClick() {
            if (this.currentAlertName === AlertType.UnfilledAmlQuestionnaire) {
                this.$router.push('/kyc/aml-questionnaire');

                return;
            }

            this.$router.push('/kyc');
            this.hideIdentityVerificationAlert();
        },
    },
});
